// extracted by mini-css-extract-plugin
module.exports = {"nameHeader":"HistoricalRequests-module__nameHeader___1qkj4","table":"HistoricalRequests-module__table___3Fo-P"};